import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Check, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SubscriptionSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAuth();
  const [status, setStatus] = useState("polling"); // polling | paid | expired | error
  const attemptsRef = useRef(0);

  useEffect(() => {
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/precios"); return; }
    let cancelled = false;

    async function poll() {
      if (cancelled) return;
      attemptsRef.current += 1;
      try {
        const { data } = await api.get(`/subscription/checkout-status/${session_id}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attemptsRef.current >= 8) { setStatus("error"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        if (attemptsRef.current >= 8) setStatus("error");
        else setTimeout(poll, 2000);
      }
    }
    poll();
    return () => { cancelled = true; };
  }, [params, navigate, user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6">
      <div className="max-w-md text-center fade-in-up">
        {status === "polling" && (
          <>
            <Loader2 className="w-14 h-14 text-[#D4A373] mx-auto mb-6 animate-spin" strokeWidth={1.25} />
            <h2 className="font-heading text-3xl font-light mb-3">{t("subscription.processing")}</h2>
            <p className="text-stone-500">{t("subscription.processingHint")}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#8FA08B] mx-auto mb-6 flex items-center justify-center">
              <Check className="w-8 h-8 text-white" />
            </div>
            <h2 className="font-heading text-4xl font-light mb-3">{t("subscription.thanks")}</h2>
            <p className="text-stone-600 mb-8">{t("subscription.thanksHint")}</p>
            <button data-testid="go-dashboard" onClick={() => navigate("/")}
              className="px-8 py-3 rounded-full bg-stone-900 text-white hover:bg-stone-800">{t("subscription.goDashboard")}</button>
          </>
        )}
        {(status === "expired" || status === "error") && (
          <>
            <h2 className="font-heading text-3xl font-light mb-3">{t("subscription.problem")}</h2>
            <p className="text-stone-500 mb-8">{t("subscription.problemHint")}</p>
            <button onClick={() => navigate("/precios")} className="px-8 py-3 rounded-full border border-stone-300 hover:bg-stone-50">{t("subscription.tryAgain")}</button>
          </>
        )}
      </div>
    </div>
  );
}
